import Text from "../../../commons/Text";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import { ReactComponent as Image } from "../images/solution.svg";
import btnClasses from "../../../commons/Button.module.scss";
import RequestDemo from "../../../Button/RequestDemo";

export default function Solution() {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.content}>
            <Title title="Solution" number={"02"} className={classes.title} />
            <Text
              text={[`Key benefits, as the result of features introduced`]}
              className={classes.text}
            />
          </div>
          <ul className={classes.list}>
            <li className={classes.item}>
              <h3>Expand business perspective</h3>
              <h4>
                Usage of NFT and AR technologies allows businesses to become an
                object of intellectual property
              </h4>
              <div className={classes.item__text}>
                <p>
                  All of WeedAr’s intellectual property becomes valuable and
                  opens up the potential for technology licensing.
                </p>
              </div>
            </li>
            <li className={classes.item}>
              <Image className={classes.image} />
            </li>
            <li className={classes.item}>
              <h3>Synergetic partnership</h3>
              <h4>
                Handy distribution platform empowered by next-generation
                technology
              </h4>
              <div className={classes.item__text}>
                <p>
                  More than 20 cannabis brands connect with customers from all
                  over the southern California region through the mediation of
                  the distributors. It became possible with the admin pannel
                  which we introduced.
                </p>
                <p>
                  Partners handle orders and their public data in their personal
                  accounts. Orders are delivered on the optimal route due to
                  integration with Google services.
                </p>
              </div>
            </li>
            <li className={classes.item}>
              <h3>Differentiation with unique user experience</h3>
              <h4>AR and NFT technologies </h4>
              <div className={classes.item__text}>
                <p>
                  The introduction of Augmented Reality technology allowed us to
                  create a unique user experience within the e-store. Users are
                  able to view the product in detail and from different angles,
                  as in real life. Developed by us, the AR engine based on ARKit
                  allowed us to customize the behavior of appearing products to
                  match the desired preferences.
                </p>
                <p>
                  Studies reveiled the potential need for collecting boxes of
                  the purchased products. We did so, and to a higher degree,
                  letting our buyers store the NFT copy of purchased items in
                  the AR stash box. This unique ownership is confirmed by
                  blockchain and makes collecting limitless. Furthermore, any of
                  those products could be sold or sent to another user with
                  transaction confirmation.{" "}
                </p>
              </div>
            </li>
          </ul>

          <RequestDemo className={`${btnClasses.button} ${classes.button}`} />
        </div>
      </div>
    </section>
  );
}
